import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import ROUTES from '@/routes';

const DesktopScreenBlocker = () => {
  const { t } = useTranslation();

  return (
    <div className='hidden text-6 desktop:flex fixed inset-0 bg-black/60 z-60  flex-col items-center justify-center backdrop-blur-lg text-white'>
      <div className='font-bold'>{t('mine.block')}</div>
      <Link
        to={ROUTES.MESSAGES.$path()}
        replace
        className='underline mt-10'>
        {t('mine.back-to-messages')}
      </Link>
    </div>
  );
};
export default DesktopScreenBlocker;
